
import OscillatorOutputs from './OscillatorOutputs.js';

export default class OutputNode {
    constructor(name, id, synth, crossFadeIndex, sequencerEngine, mixSession, context) {
        this.sequencerEngine = sequencerEngine;
        this.mixSession = mixSession;
        this.context = context;

        this.id = id;
        this.name = name;
        this.synth = synth;
        this.crossFadeIndex = crossFadeIndex;

        let oscs = synth.oscillatorNodes;
        this.outputs = {};
        this.voices = [];
    }

    dispose() {
        for (let osc in this.outputs) {
            this.outputs[osc].dispose();
        }
        this.outputs = {};
    }

    newVoice() {
        for (let osc in this.outputs) {
            this.outputs[osc].newVoice();
        }
    }

    removeVoice() {
        for (let osc in this.outputs) {
            this.outputs[osc].removeVoice();
        }
    }

    stealOrMake(osc) {
        if (this.outputs[osc.name]) {
            return this.outputs[osc.name];
        }
        let found = undefined;
        for (let o in this.outputs) {
            if (!this.outputs[o].connected) {
                // then we need to steal this one
                let oscToSteal = this.outputs[o];
                delete this.outputs[o];
                return oscToSteal;
            }
        }
        return new OscillatorOutputs(
                osc, this.sequencerEngine, this.mixSession, this.context);
    }

    connect(osc) {
        let oscOutputs = this.stealOrMake(osc);
        this.outputs[osc.name] = oscOutputs;

        // first connect the voice to the amp envelope
        for (let i in osc.voices) {
            let voice = osc.voices[i];
            if (!oscOutputs.ampEnvelopes[i]) {
                oscOutputs.newVoice();
            }
            let output = oscOutputs.ampEnvelopes[i].envelope;
            voice.connect(output);
        }
        oscOutputs.connected = true;

        // then connect each amp envelope to the same formants input (
        // they will be mixed together at this point)
        oscOutputs.ampEnvelopes.forEach(
            ({envelope}) => envelope.connect(osc.formantsManager.input));

        // connect the output of the formants to the cross-fader. 
        osc.formantsManager.output.connect(
            this.synth.outputCrossFade, 0, this.crossFadeIndex);

        return () => {
            oscOutputs.connected = false;
            oscOutputs.ampEnvelopes.forEach(
                ({envelope}) => envelope.disconnect(osc.formantsManager.input));

            osc.voices.forEach(
                (voice, i) => {
                    voice.disconnect(oscOutputs.ampEnvelopes[i].envelope);
                });

            osc.formantsManager.output.disconnect(
                this.synth.outputCrossFade, 0, this.crossFadeIndex);
            oscOutputs.disconnect = undefined;
        };
    }
}
